import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Participant } from 'livekit-client';
import PresentToAll from '@mui/icons-material/PresentToAll';
import { selectIsModerator } from '../../../redux/slices/auth';
import {
  IConferenceParticipant,
  useScreensharePinnedMutation,
} from '../../../redux/streamGoApi';
import { Tooltip } from '../../Form';

interface IScreensharePinnedIcon {
  conferenceParticipant?: IConferenceParticipant;
  participant?: Participant;
  roomId: string;
}

export const ScreensharePinnedIcon = ({
  conferenceParticipant,
  participant,
  roomId,
}: IScreensharePinnedIcon) => {
  const isModerator = useSelector(selectIsModerator);
  const [updateScreensharePinned] = useScreensharePinnedMutation();

  const isSgVmParticipant = participant?.identity
    .toLowerCase()
    .startsWith('sg_vm');

  const tooltipText = conferenceParticipant?.ScreensharePinned
    ? 'Unpin screenshare'
    : 'Pin screenshare';

  const toggleScreensharePinned = useCallback(() => {
    if (participant?.sid && !isSgVmParticipant) {
      updateScreensharePinned({
        roomId,
        Participant: {
          ScreensharePinned: !conferenceParticipant?.ScreensharePinned,
          UserId: participant?.sid,
        },
      });
    }
  }, [
    conferenceParticipant?.ScreensharePinned,
    isSgVmParticipant,
    participant?.sid,
    roomId,
    updateScreensharePinned,
  ]);

  if (!isModerator || isSgVmParticipant) return null;

  return (
    <Tooltip title={tooltipText}>
      <PresentToAll
        className={
          conferenceParticipant?.ScreensharePinned ? 'icon-on' : 'icon-off'
        }
        onClick={toggleScreensharePinned}
      />
    </Tooltip>
  );
};
